export enum OPERATOR_SERVICE_CENTER_PAGES {
  DOCUMENT_PAGE,
  BORROWER_PAGE,
  BORROWER_RESTRICTION_PAGE,
  PRE_APPLICATION_RESULT_PAGE,
}
